export const API_INVALID_APP_TOKEN_ERROR_CODE = '10020'
export const API_INVALID_GEOLOCATION_ERROR_CODE = '10021'
export const API_INVALID_ON_SITE_SECURITY = '10023'

export const APP_TOKEN_QUERY_PARAM = 'at'
